var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgChevronUp = function SvgChevronUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.54 5.54a.65.65 0 0 1 .92 0l4 4a.65.65 0 1 1-.92.92L8 6.92l-3.54 3.54a.65.65 0 1 1-.92-.92l4-4Z",
    fill: "currentColor"
  })));
};

export { SvgChevronUp as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik03LjUzOTk5IDUuNTQwMzdDNy43OTM4MyA1LjI4NjUzIDguMjA1MzkgNS4yODY1MyA4LjQ1OTIzIDUuNTQwMzdMMTIuNDU5MiA5LjU0MDM3QzEyLjcxMzEgOS43OTQyMiAxMi43MTMxIDEwLjIwNTggMTIuNDU5MiAxMC40NTk2QzEyLjIwNTQgMTAuNzEzNSAxMS43OTM4IDEwLjcxMzUgMTEuNTQgMTAuNDU5Nkw3Ljk5OTYxIDYuOTE5MjNMNC40NTkyMyAxMC40NTk2QzQuMjA1MzkgMTAuNzEzNSAzLjc5MzgzIDEwLjcxMzUgMy41Mzk5OSAxMC40NTk2QzMuMjg2MTUgMTAuMjA1OCAzLjI4NjE1IDkuNzk0MjIgMy41Mzk5OSA5LjU0MDM3TDcuNTM5OTkgNS41NDAzN1oiIGZpbGw9ImN1cnJlbnRDb2xvciIgLz4KPC9zdmc+Cg==";